import React from "react";
import "./HomepageGoogleReview.module.scss";
import { REVIEW_LIFEPAL_JSON, GOOGLE_REVIEW_DATA } from "../../../shared/constants";
import HomepageSlider from "../../../components/Slider/HomepageSlider";

const HomepageGoogleReview = () => (
  <div className="g-review-wrapper">
    <div className="g-review-header">
      <div className="g-review-title">
        <h2 >
          Testimoni Nasabah Lifepal
        </h2>

        <p className="g-review-title-text">
          Didapatkan 100% asli dari pelanggan kami, tanpa edit sama sekali.
        </p>
      </div>

      <div className="g-review-google-card">
        <div className="g-review-google-card-header">
          <img
            src={"/static/images/homepage/google.svg"}
            alt="Lifepal Google Review"
            className="g-review-google-card-image"
          />
          <div className="google-card-detail">
            <p className="google-cart-title">
              Ulasan nyata nasabah Lifepal yang transparan!
            </p>

            <div className="google-cart-rate">
              <div
                className="google-cart-rate-star"
                style={{"--rating": String(GOOGLE_REVIEW_DATA.rating)}}
              >
                <img
                  src="/static/images/icons/star-outline.svg"
                  alt=""
                />
              </div>

              <p className="google-start-text">{GOOGLE_REVIEW_DATA.rating}/5.0</p>
            </div>
          </div>
        </div>

        <p className="google-card-footer">
          <span>Dari {GOOGLE_REVIEW_DATA.totalReviews}&nbsp;</span>

          <a
            href={GOOGLE_REVIEW_DATA.reviewUrl}
            target="_blank"
            className="google-card-link"
            rel="noopener noreferrer"
          >
            Google reviews
          </a>

          <span>&nbsp;Per {GOOGLE_REVIEW_DATA.asOf}</span>
        </p>
      </div>
    </div>
    <div className="g-review-card-wrapper">
      <HomepageSlider
        sliderData={{
          desktop: {
            height: 172,
            width: 262,
            visibleItems: 4,
          },
          mobile: {
            height: 152,
            width: 312,
          },
        }}
        items={REVIEW_LIFEPAL_JSON.map((item, index) => (
          <div
            className="g-review-card-item"
            key={`g-review-card-item-${index}`}
          >
            <img
              src={"/static/images/homepage/double-quot.svg"}
              alt=""
              className="g-review-card-icon"
            />
            <div className="g-review-card">
              <p className="g-review-card-title">{item.name}</p>

              <p className="g-review-card-date">{item.date}</p>

              <div className="google-cart-rate">
                <div
                  className="google-cart-rate-star"
                  style={{"--rating": `${item.rating}`}}
                >
                  <img
                    src="/static/images/icons/star-outline.svg"
                    alt=""
                  />
                </div>

                <p className="google-start-text">{item.rating}/5</p>
              </div>

              <p className="g-review-card-comment">{item.review}</p>
            </div>
          </div>
        ))}
      />
    </div>
  </div>
);

export default HomepageGoogleReview;
